var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "add-item-to-basket-overlay--mobile",
      class: {
        "is-single": _vm.templateEvent == "tpl.item",
        "add-item-to-basket-overlay--mobile": _vm.isMobile
      },
      attrs: { id: "add-item-to-basket-overlay" }
    },
    [
      _c("div", { staticClass: "modal fade" }, [
        _c(
          "div",
          {
            staticClass: "modal-dialog",
            class: { "has-crossselling": _vm.hasCrossselling },
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header-mobile" }, [
                _c(
                  "button",
                  {
                    staticClass: "close ml-0 pl-1",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                    }
                  },
                  [
                    _c("svg", { attrs: { width: "18", height: "18" } }, [
                      _c("use", {
                        attrs: {
                          "xlink:href": "#svg_close",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "headline" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "51",
                        height: "51",
                        viewBox: "0 0 51 51",
                        fill: "none"
                      }
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "25.5",
                          cy: "25.5",
                          r: "25.5",
                          fill: "#333333"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M36 18L22.25 32L16 25.6364",
                          stroke: "white",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Artikel ist im Warenkorb")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "button-wrapper row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass: "btn btn-outline-primary btn-medium mr-2",
                        attrs: { href: _vm.urls.basket, rel: "nofollow" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.singleItemBasket")
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass: "btn btn-primary btn-medium",
                        attrs: { href: _vm.urls.checkout, rel: "nofollow" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-arrow-right",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemCheckout"
                              )
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.hasCrossselling
                ? _c("div", { staticClass: "modal-body-mobile" }, [
                    _c("div", { staticClass: "body-headline" }, [
                      _vm._v("Gleich mitbestellen")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "items-wrapper" },
                      [
                        _vm._l(_vm.items, function(item) {
                          return [
                            _c("category-item", {
                              key: item.id,
                              attrs: {
                                "item-data": item.data,
                                "is-overlay": true
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasCrossselling
                ? _c("div", { staticClass: "modal-footer-mobile" }, [
                    _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": _vm.$translate(
                            "Ceres::Template.closeIcon"
                          )
                        }
                      },
                      [_vm._v("\n            Weiter shoppen\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        attrs: { href: _vm.urls.basket, rel: "nofollow" }
                      },
                      [_vm._v("\n            Zum Warenkorb\n          ")]
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }